<template>
  <div class="login_container">
    <div class="left_right">
      <div class="introduction">
        <el-timeline style="margin-top: 90px; margin-right: 80px">
          <el-timeline-item
            v-for="(timeLine, index) in timeLineList"
            :type='handleType(index)'
            size="large"
            :key="index"
            :timestamp="timeLine.times"
            placement="bottom"
            @click.native="getReportStudyId(index,timeLine.studyId)"
            >
            <span>{{timeLine.studyModality}}</span>
            <span v-if="timeLine.partExamined == 'BREAST'">乳腺</span>
            <span v-else-if="timeLine.partExamined == 'HEAD'">头部</span>
            <span v-else-if="timeLine.partExamined == 'NECK'">颈部</span>
            <span v-else-if="timeLine.partExamined == 'CHEST'">胸部</span>
            <span v-else-if="timeLine.partExamined == 'ABDOMEN'">腹部</span>
            <span v-else-if="timeLine.partExamined == 'UPPER EXTREMITIES'"
              >上肢</span
            >
            <span v-else-if="timeLine.partExamined == 'LOWER EXTREMITIES'"
              >下肢</span
            >
            <span v-if="timeLine.abnormal == 0">阴性</span>
            <span v-else-if="timeLine.abnormal == 1">阳性</span>
            <span v-else>暂无</span>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="text_right">
      <div class="introduction">
        <div id="li_listers" class="introduction_lefts">
          <div class="datahtml" v-html="datahtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pdfconent",
  data() {
    return {
      selectIndex: 0,
      datahtml: "",
      patientId:"",
      timeLineList: [],
    };
  },
  created(e) {
    this.patientId = this.$router.currentRoute.query.patientId;
    this.initTimeLine();
  },
  methods: {
    handleType(index){
      if(index == this.selectIndex){
        return 'success'
      }else{
        return ''
      }
    },
    getReportStudyId(index,studyId) {
      this.selectIndex = index
      depot
        .get({
          url: "/v1/report/exportReportHtmlByStudyId",
          params: {
            token: sessionStorage.getItem("token"),
            studyId: studyId,
          },
        })
        .then((res) => {
          console.log(res);
          this.datahtml = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initTimeLine() {
      depot
        .get({
          url: "/v1/study/listCompleteStudies",
          params: {
            page: 1,
            pageSize: 200,
            token: sessionStorage.getItem("token"),
            patientId: this.patientId,
            status: 5,
          },
        })
        .then((res) => {
          this.timeLineList = res.data.list;
          this.timeLineList.forEach((element) => {
            element.times = this.time(element.studyDatetime);
          });
          this.getReportStudyId(this.selectIndex,this.timeLineList[0].studyId)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
  },
};
</script>

<style lang="scss">
* {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari */
  color-adjust: exact !important; /*Firefox*/
}
.selectwidth {
  width: 100%;
}
.button_box {
  padding-bottom: 20px;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.addProp .el-dialog .el-dialog__body {
  padding: 0px !important;
}
.addProp .el-dialog .el-dialog__header {
  background: #f8f8f8 !important;
  border-bottom: 1px solid #eee !important;
}
.header_prop div:first-child {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  // border: 2px solid #fff;
  padding-bottom: 5px;
  box-sizing: border-box;
}
.header_prop div:last-child {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  // border: 2px solid #fff;
  padding-bottom: 5px;
  box-sizing: border-box;
}
.header_propactive {
  border-bottom: 2px solid #009b43 !important;
  padding-bottom: 3px !important;
}
.header_prop {
  display: flex;
  margin-bottom: 20px;
}
.left_prop {
  display: flex;
  flex-direction: column;
  // border-right: 1px solid #7e7e7e;
  margin-left: 20px;
  margin-top: 10px;
}
.setRight {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  background: #f2f2f2;
}
.body_from {
  display: flex;
}
.setBox {
  height: 500px;
  width: 300px;
  // border-right: 1px solid #7e7e7e;
  overflow-y: scroll;
  overflow-x: scroll;
}
.dev-type-main-left {
  overflow: auto;
  padding: 10px;
  .right-menu {
    z-index: 1;
    position: absolute;
    height: 100px;
    width: 100px;
    position: absolute;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: white;
    .menu-item {
      //display: block;
      line-height: 20px;
      text-align: left;
      margin-top: 10px;
      font-size: 14px;
      color: #606266;
    }
    li:hover {
      background-color: #edf6ff;
      color: #606266;
    }
  }
}
.timetime {
  color: #7e7e7e;
}
.process_box {
  margin-top: 23px;
  height: 200px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.circular {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #c4c4c4;
  margin-right: 15px;
}
.process_box .process:first-child .circular {
  background: #009b43;
}
.process_box .process:last-child .circular::after {
  display: none;
}
.circular::after {
  position: absolute;
  content: "";
  width: 1px;
  left: 6px;
  // margin-left: -6px;
  top: 12px;
  height: 55px;
  background: #f0f0f0;
}
.process {
  display: flex;
  align-items: baseline;
  margin-bottom: 15px;
}
.button_technological {
  margin-top: 18px;
}
.technological {
  width: 330px;
  background: #fff;
}
.Vector {
  width: 37px;
  height: 37px;
  object-fit: contain;
}
.li_box .li_list:last-child {
  border-bottom: 0px;
  padding-bottom: 0px;
}
.li_box {
  width: 48px;
  background: #fff;
  padding: 9px 10px 9px 10px;
  box-sizing: border-box;
  height: max-content;
}
.li_list p {
  color: #5f5f5f;
  text-align: center;
}
.li_list {
  cursor: pointer;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  margin-bottom: 15px;
}
.Inspection {
  margin-top: 20px;
  margin-bottom: 20px;
}
.Inspection span:first-child {
  margin-right: 8px;
  color: #5f5f5f;
}
.usercontent span {
  margin-right: 40px;
}
.header_intro {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.introduction_lefts {
  width: 100%;
  margin-right: 27px;
  background: #fff;
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}
.datahtml {
  padding-top: 60px;
  padding-bottom: 60px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.introduction {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.left_right {
  width: 36;
}
.text_right {
  width: 64%;
}
.timeout {
  width: 100%;
  height: 42px;
  background: rgba(237, 111, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
}
.buttomPreview {
  margin-top: 20px !important;
}
.bodyPreview div:first-child {
  color: #797c7a;
}
.bodyPreview div:last-child {
  margin-top: 5px;
}
.bodyPreview {
  margin-top: 10px;
  padding-left: 10px;
  box-sizing: border-box;
}
.first_preview {
  padding: 10px 0px;
  background: rgba(0, 155, 67, 0.05);
  padding-left: 15px;
  box-sizing: border-box;
}
.previewBox {
  margin-top: 20px;
}
.bodyBox_child {
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.bodyBox {
  padding: 6px 9px;
  margin-top: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 350px;
  overflow-y: scroll;
  border-radius: 5px;
}
.setUp {
  width: 16%;
  height: 40px;
  color: black;
  background: rgba(0, 155, 67, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: 15px;
  cursor: pointer;
}
.headerBox {
  display: flex;
  padding: 6px 9px;
  box-sizing: border-box;
  width: 100%;
}

.text_left {
  box-sizing: border-box;
}
.box_regis {
  display: flex;
  margin-right: 15px;
  width: 32%;
}
.yinyang_regis span:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.yinyang_regis span:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.yinyang_regis {
  display: flex;
}
.register {
  cursor: pointer;
  width: 50%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  // background: rgba(0, 155, 67, 0.05);
  font-size: 14px;
  opacity: 0.8;
}
.YinYang {
  cursor: pointer;
  width: 86px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  border: 1px solid #cecece;
  font-size: 14px;
  opacity: 0.8;
}
.registeractive {
  cursor: pointer;
  color: #fff;
  background: #009b43;
}
.YinYangactive {
  background: #ed6f00;
  cursor: pointer;
  color: #fff;
  border: 1px solid #ed6f00;
}
.text_left {
  width: 260px;
  height: 90vh;
  background: #fff;
}
.login_container {
  display: flex;
  // height: 100%;
  margin-top: 10px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/lookimagehistory/index.vue